'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import UIConfirmDialog from './UIConfirmDialog';
import UIModal from './UIModal';
export default class UIConfirmModal extends Component {
  render() {
    return /*#__PURE__*/_jsx(UIModal, Object.assign({}, this.props, {
      ModalDialog: UIConfirmDialog
    }));
  }

}
UIConfirmModal.displayName = 'UIConfirmModal';
UIConfirmModal.propTypes = Object.assign({}, UIConfirmDialog.propTypes, {
  _contextual: PropTypes.bool
});
UIConfirmModal.defaultProps = Object.assign({}, UIConfirmDialog.defaultProps, {
  onReject: emptyFunction,
  _contextual: false
});